import chatbotRequest from '../http'
import type { CreateWebwidgetChannelReq, CreateWebwidgetChannelRes } from '../types/createWebwidgetChannel'

export function createWebwidgetChannelApi(data: CreateWebwidgetChannelReq): Promise<CreateWebwidgetChannelRes> {
    return chatbotRequest<CreateWebwidgetChannelRes, CreateWebwidgetChannelReq, CreateWebwidgetChannelRes>({
        url: '/api/channel/create/webwidget',
        method: 'post',
        data,
    })
}